import { render, staticRenderFns } from "./HeaderInformationNavigationBfz.vue?vue&type=template&id=f4a0be0e&scoped=true"
import script from "./HeaderInformationNavigationBfz.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationBfz.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationBfz.vue?vue&type=style&index=0&id=f4a0be0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a0be0e",
  null
  
)

export default component.exports